<template>
  <v-app id="inspire">
    <v-main>
      <v-container
          class="fill-height"
          fluid
      >
        <v-row
            align="center"
            justify="center"
        >
          <v-col
              cols="12"
              sm="8"
              lg="4"
          >
            <v-img
                class="elevation-0"
                :src="require('../assets/img/logo.png')"
                width="100"
                aspect-ratio="1"
                style="float: right"
            ></v-img>
            <h2 class="text-center font-weight-black display-4 mb-8">ALCALI</h2>
            <v-card class="elevation-12">
              <v-toolbar
                  color="black"
                  dark
                  flat
              >
                <v-toolbar-title>{{ $t('views.Login.LoginTitle') }}</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-form @keyup.native.enter="authenticate">
                <v-card-text>
                  <v-text-field
                      :label="$t('views.Login.Login')"
                      name="login"
                      v-model="username"
                      prepend-icon="person"
                      type="text"
                  ></v-text-field>

                  <v-text-field
                      :label="$t('views.Login.Password')"
                      v-model="password"
                      name="password"
                      prepend-icon="lock"
                      type="password"
                  ></v-text-field>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" dark @click.prevent="authenticate">{{ $t('views.Login.SignIn') }}</v-btn>
                </v-card-actions>
              </v-form>
            </v-card>
          </v-col>
          <v-col sm="12" align="center" v-if="ssoEnabled">
            <v-btn @click="handleSsoLogin">Login with SSO</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
  export default {
    name: "Login",
    data: () => ({
      username: null,
      password: null,
      ssoEnabled: false,
      provider: null,
      clientId: null,
      redirectUri: null,
      oidcEndpoint: null,
    }),
    methods: {
      authenticate() {
        let username = this.username
        let password = this.password

        this.$store.dispatch("login", { username, password })
          .then(() => this.$router.push("/"))
          .catch(() => {
            this.$toast.error(this.$t("views.Login.InvalidCredentials"))
          })
      },
      handleSsoLogin() {
        // Random URL-safe state and nonce so social-auth-core can validate the
        // id_token after we POST the code back to /api/social/login/.
        const randomToken = () => {
          const buf = new Uint8Array(16)
          window.crypto.getRandomValues(buf)
          return Array.from(buf, b => b.toString(16).padStart(2, "0")).join("")
        }
        const state = randomToken()
        const nonce = randomToken()
        localStorage.setItem("oidc_redirect_uri", this.redirectUri)
        localStorage.setItem("oidc_provider", this.provider)
        localStorage.setItem("oidc_state", state)
        localStorage.setItem("oidc_nonce", nonce)
        const params = new URLSearchParams({
          client_id: this.clientId,
          response_type: "code",
          redirect_uri: this.redirectUri,
          scope: "openid profile email",
          state: state,
          nonce: nonce,
        })
        // Discover the authorization endpoint from the OIDC well-known config.
        const discoveryUrl = this.oidcEndpoint.replace(/\/?$/, "/") + ".well-known/openid-configuration"
        fetch(discoveryUrl)
          .then(r => r.json())
          .then(meta => {
            window.location.href = meta.authorization_endpoint + "?" + params.toString()
          })
          .catch(() => {
            this.$toast.error(this.$t("views.Login.Unauthorized"))
          })
      },
    },
    mounted() {
      this.$http.get("api/social/").then(response => {
        this.provider = response.data.provider
        this.clientId = response.data.client_id
        this.redirectUri = response.data.redirect_uri
        if (this.provider === "authentik-oidc") {
          this.oidcEndpoint = response.data.oidc_endpoint
        }
        this.ssoEnabled = true
      }).catch(() => {
        // SSO not configured, only local login available
      })
    },
  }
</script>
<style scoped>
  html {
    overflow-y: auto !important
  }

</style>
